import React, { Suspense, Component } from 'react';
import "./styles/root.css";

import Header from './components/Header.js';
import Cabinet from './components/Cabinet.js';
import Login from "./components/Login.js";
import Register  from "./components/Register.js";
import RecoverPass from "./components/RecoverPass.js";
import ForgotPass from './components/ForgotPass';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';


export default class App extends Component {


  
  render () {
    
    return (
      <Router>

      <div id="App"  className="App">
                  <Route path="/" exact component={Cabinet}/>
                  <Route path="/login" exact component={Login}/>
                  <Route path="/register" exact component={Register}/>
                  <Route path="/register/:mid" exact component={Register}/>
                  <Route path="/cabinet" exact component={Cabinet}/>
                  <Route path="/forgotpass" exact component={ForgotPass}/>
                  <Route path="/resetpassword/:email/:code+/:role" component={RecoverPass} />
      </div>
      </Router>


    );
  }
}
